<template>
  <div class="ui-fake-scroll-box"
       :class="{
         'mobile': isMobile
       }">
    <div class="scroll-box">
      <slot />
    </div>
    <div class="fake-scroll-track">
      <div class="fake-scroll-bar"></div>
    </div>
  </div>
</template>

<script>
import browser from '../../libs/browser'

export default {
  name: 'UiFakeScrollBox',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    isMobile () {
      return browser.isMobile
    }
  },
  created () {
  },
  mounted () {
    this._$contentBox = this.$el.querySelector('.scroll-box')
    this._$track = this.$el.querySelector('.fake-scroll-track')
    this._$bar = this.$el.querySelector('.fake-scroll-bar')

    this._scrollableSize = 0
    this._barDowPposition = null
    this._barCurrentPosition = null
    this._barMaxPosition = null

    this._$contentBox.addEventListener('mouseenter', this.refresh)
    this._$contentBox.addEventListener('scroll', this.onScroll)
    this._$bar.addEventListener('mousedown', this.barDown)

    this.refresh()
    this.onScroll()
  },
  methods: {
    onScroll () {
      this._scrollTop = this._$contentBox.scrollTop
      this.$emit('onScroll', this._scrollTop, this._scrollHeight, this._scrollableSize)
      this.setTrack(this._scrollTop)
    },
    barDown (e) {
      this._barDowPposition = e.pageY
      this._barCurrentPosition = parseInt(this._$bar.style.top || 0)
      document.documentElement.addEventListener('mousemove', this.barMove)
      document.documentElement.addEventListener('mouseup', this.barUp)
      this._$track.classList.add('active')
      e.preventDefault()
    },
    barMove (e) {
      const current = Math.max(0, Math.min(this._barMaxPosition, this._barCurrentPosition + (e.pageY - this._barDowPposition)))
      const scrollTop = Math.round((this._scrollableSize * current) / this._barMaxPosition)
      this._$bar.style.top = current + 'px'
      this._$contentBox.scrollTop = scrollTop
      return e.preventDefault()
    },
    barUp (e) {
      document.documentElement.removeEventListener('mousemove', this.barMove)
      document.documentElement.removeEventListener('mouseup', this.barUp)
      this._$track.classList.remove('active')
    },
    setTrack (scrollTop) {
      this._$bar.style.top = (this._barMaxPosition * scrollTop) / this._scrollableSize + 'px'
    },
    hideTrack () {
      this._$track.classList.add('hide')
    },
    showTrack () {
      this._$track.classList.remove('hide')
    },
    scrollTop (value) {
      this._$contentBox.scrollTop = value
    },
    refresh () {
      const size = this._$contentBox.clientHeight
      const scrollHeight = this._$contentBox.scrollHeight
      const barHeight = Math.max(20, (this._$track.offsetHeight * size) / scrollHeight)
      this._$bar.style.height = barHeight + 'px'
      this._barMaxPosition = this._$track.offsetHeight - barHeight
      this._scrollableSize = scrollHeight - size
      if (this._scrollableSize > 0) {
        this._$contentBox.classList.remove('no-scroll-bar')
        this._$track.style.visibility = 'visible'
      } else {
        this._$contentBox.classList.add('no-scroll-bar')
        this._$track.style.visibility = 'hidden'
      }
      this.setTrack(this._$contentBox.scrollTop)
      this._scrollHeight = scrollHeight
    }
  }
}
</script>

<style lang="scss">
.ui-fake-scroll-box {
  position: relative;
  width: 100%;
  height: 100%;

  &.mobile .fake-scroll-track {
    display: none;
  }
}

.scroll-box {
  width: 100%;
  height: 100%;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
  }
}

.fake-scroll-track {
  position: absolute;
  right: 5px;
  top: 5px;
  bottom: 5px;
  width: 8px;
  background: rgba(0, 0, 0, 0);
  z-index: 1;
  transition: opacity 0.15s ease-out;

  &.hide {
    opacity: 0;
  }

  .fake-scroll-bar {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 50px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
}
</style>
